export const getPrevSearchParams = (prev: URLSearchParams, keys?: string[], withoutKeys?: string[]) => {
    const prevSearchParams = Object.fromEntries(prev.entries());


    if (withoutKeys?.length && !keys?.length) {
        let newSearchParams: Record<string, string> = {};
        for (const key in prevSearchParams) {
            if (withoutKeys.includes(key)) {
                continue
            }
            newSearchParams[key] = prevSearchParams[key]
        }
        return newSearchParams
    }

    if (!keys?.length) {
        return prevSearchParams
    }

    let newSearchParams: Record<string, string> = {};
    keys.forEach((key) => {
        if (key in prevSearchParams) {
            if (withoutKeys?.length && withoutKeys.includes(key)) {
                return
            }
            newSearchParams[key] = prevSearchParams[key]
        }
    })
    return newSearchParams;
}

export function addQueryParamsWithoutRouter(params: { [key: string]: string }): void {
    const url = new URL(window.location.href);

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            url.searchParams.set(key, params[key]);
        }
    }

    window.history.replaceState({}, '', url.toString());
}

export function getQueryParams(key: string): string | null {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
}